import { IProjectConfig, IProjectLogo } from "@shared/model/projects";
import { ILockValues, IProgressResponse } from ".";

export interface IProjectState extends ILockValues {
  id: number | null;
  name: string;
  currency_multiplication: string;
  currency: string;
  credits_tab: boolean;
  leasings_tab: boolean;
  own_capitals_tab: boolean;
  capexs_tab: boolean;
  financing_type: number | null;
  can_balance_view: boolean;
  can_load_files: boolean;
  can_output_to_excel: boolean;
  can_results_view: boolean;
  can_view_rating: boolean;
  working_capital_tab: boolean;
  venture_tab: boolean;
  nav_btn_click: number;
  calc_id: number | null;
  progress: IProgressResponse | {};
  project_mode: string;
  projectConfig: IProjectConfig | null;
  max_variants: number;
	project_subscribers_count: number;
	logo: IProjectLogo | null;
	show_rating_to_investors: boolean;
  current_user_subscribed_to_project: boolean;
}